<script>
  export let option
</script>

{#if option}
  <input
    type="hidden"
    name="options[{option.optionTypeId}]"
    value={option.id}
  />
{/if}
